// src/components/Footer/index.js - UPDATED WITH NEAREST STORE
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, CalendarDays } from 'lucide-react';
import { formatStoreHours } from '../../utils/storeUtils';
import { apiCache } from '../../utils/apiCache';
import './index.css';

const FooterSection = ({ config, nearestStore, showNewsletter = true }) => {
    const { footer } = config;

    const displayStore = nearestStore || null;
    const storeHours = displayStore && displayStore.week_schedule
        ? formatStoreHours(displayStore.week_schedule)
        : [];

    // Check if there's only a single store in the entire system
    const branches = apiCache.getBranches() || [];
    const isSingleStore = branches.length === 1;

    // Format schedules for all branches if there are multiple stores
    const formattedBranches = branches.map(branch => {
        const cached = apiCache.getStoreDetails(branch.id);
        const scheduleToUse = cached?.week_schedule || branch.week_schedule;
        return {
            name: branch.name,
            hours: scheduleToUse ? formatStoreHours(scheduleToUse) : []
        };
    });

    // Safely determine if distance is valid to prevent NaN
    const hasValidDistance = displayStore &&
        displayStore.distance !== null &&
        displayStore.distance !== undefined &&
        !isNaN(parseFloat(displayStore.distance));

    let copyrightText = footer.copyright || "";
    let poweredByHTML = null;

    if (typeof copyrightText === 'string' && copyrightText.includes(' is powered by ')) {
        const parts = copyrightText.split(' is powered by ');
        copyrightText = parts[0];
        if (parts[1]) {
            poweredByHTML = "Powered by " + parts[1];
        }
    }


    return (
        <div id="footer" className="footer-main">
            {showNewsletter && footer?.newsletter && (
                <div className="footer-news pad-top-100 pad-bottom-70 parallax">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">
                                    <h2 className="ft-title color-white text-center">{footer.newsletter.heading}</h2>
                                    <p className="text-center">{footer.newsletter.description}</p>

                                </div>
                                <form>
                                    <input type="email" placeholder="Enter your e-mail id" />
                                    <button type="submit" className="submit-btn" onClick={(e) => e.preventDefault()}>Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="footer-box">
                <div className="container">
                    <div className="row">
                        <div className="footer-in-main">

                            <div className="footer-logo-col">
                                <img src={config.logo} alt={config.name} />
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="footer-box-a">
                                    <h3>{footer.about.heading}</h3>
                                    <p>{footer.about.description}</p>
                                    {footer.about.social && footer.about.social.length > 0 && (
                                        <ul className="socials-box footer-socials pull-left">
                                            {footer.about.social.map((social, index) => (
                                                <li key={index}>
                                                    <a href={social.href} target="_blank" rel="noopener noreferrer">
                                                        <div className="social-circle-border">
                                                            <i className={social.icon}></i>
                                                        </div>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="footer-box-b">
                                    <h3>{footer.whyChooseUs.heading}</h3>
                                    <ul>
                                        {footer.whyChooseUs.items.map((item, index) => (
                                            <li key={index}><a>{item}</a></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="footer-box-c">
                                    <h3>
                                        {(displayStore && isSingleStore) ? 'Our Address' : footer.contact.heading}
                                    </h3>

                                    {(displayStore && isSingleStore) ? (
                                        <>
                                            <p className="footer-contact-item">
                                                <MapPin size={16} className="footer-icon" />
                                                <span>
                                                    {displayStore.address}, {displayStore.city}, {displayStore.state} - {displayStore.zip_code}
                                                </span>
                                            </p>
                                            <p className="footer-contact-item">
                                                <Phone size={16} className="footer-icon" />
                                                <span>{displayStore.phone}</span>
                                            </p>
                                            <p className="footer-contact-item">
                                                <Mail size={16} className="footer-icon" />
                                                <span>
                                                    <a href={`mailto:${displayStore.email}`}>
                                                        {displayStore.email}
                                                    </a>
                                                </span>
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            {footer.contact.address && (
                                                <p className="footer-contact-item">
                                                    <MapPin size={16} className="footer-icon" />
                                                    <span>{footer.contact.address}</span>
                                                </p>
                                            )}
                                            {footer.contact.phone && (
                                                <p className="footer-contact-item">
                                                    <Phone size={16} className="footer-icon" />
                                                    <span>{footer.contact.phone}</span>
                                                </p>
                                            )}
                                            {footer.contact.email && (
                                                <p className="footer-contact-item">
                                                    <Mail size={16} className="footer-icon" />
                                                    <span>
                                                        <a href={`mailto:${footer.contact.email}`}>
                                                            {footer.contact.email}
                                                        </a>
                                                    </span>
                                                </p>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="footer-box-d">
                                    <h3>
                                        {isSingleStore && displayStore ? `${displayStore.name} Hours` : footer.hours.heading}
                                    </h3>
                                    {isSingleStore ? (
                                        <ul className="footer-hours-list footer-hours-compact">
                                            {storeHours.length > 0 ? (
                                                storeHours.map((schedule, index) => (
                                                    <li key={index} className="footer-hours-item">
                                                        <span className="footer-day">{schedule.day || schedule.days}</span>
                                                        <span className="footer-time">{schedule.time}</span>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="footer-hours-item">
                                                    <span className="footer-day">{displayStore ? 'Hours unavailable' : 'Select a branch'}</span>
                                                </li>
                                            )}
                                        </ul>
                                    ) : (
                                        <div className={`footer-multi-hours ${formattedBranches.length > 2 ? 'two-columns' : 'one-column'}`}>
                                            {formattedBranches.map((branch, bIndex) => (
                                                <div key={bIndex} className="footer-branch-hours-group">
                                                    <h4 className="footer-branch-title">
                                                        {branch.name}
                                                    </h4>
                                                    <ul className="footer-hours-list footer-hours-compact">
                                                        {branch.hours.length > 0 ? (
                                                            branch.hours.map((schedule, index) => (
                                                                <li key={index} className="footer-hours-item">
                                                                    <span className="footer-day">{schedule.day || schedule.days}</span>
                                                                    <span className="footer-time">{schedule.time}</span>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li className="footer-hours-item">
                                                                <span className="footer-day">Hours unavailable</span>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="copyright" className="copyright-main">
                    <div className="container">
                        <div className="copyright-inner-container">
                            <div className="copyright-center">
                                <div className="copyright-and-policies">
                                    <span className="copy-title">{copyrightText}</span>
                                    {footer.policies && footer.policies.length > 0 && (
                                        <>
                                            <span className="policy-separator"> | </span>
                                            {footer.policies.map((policy, index) => (
                                                <React.Fragment key={index}>
                                                    <Link to={policy.path} className="policy-link">{policy.name}</Link>
                                                    {index < footer.policies.length - 1 && (
                                                        <span className="policy-separator"> | </span>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </>
                                    )}
                                </div>
                                <div className="powered-by-text">
                                    Powered by <a href="https://www.ritaya.in/" target="_blank" rel="noopener noreferrer">Ritaya&trade;</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterSection;
